export default __webpack_public_path__ + "static/media/whatsapp.be8b84bc.svg";